import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { apiUrl } from "../config/config";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

/* =========================
   CHECKOUT FORM
========================= */
const CheckoutForm = ({ orderData, onSuccess, validateForm }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  const handlePayment = async (e) => {
    e.preventDefault();

    // 🔴 STOP if billing form invalid
    if (!validateForm()) return;

    if (!stripe || !elements || loading) return;

    setLoading(true);

    const cardElement = elements.getElement(CardElement);
    if (!cardElement) {
      setLoading(false);
      return;
    }

    try {
      // 1️⃣ Create payment intent
      const res = await fetch(`${apiUrl}/api/stripe/create-payment-intent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: orderData.total,
          currency: "usd",
        }),
      });

      const { client_secret } = await res.json();

      // 2️⃣ Confirm payment
      const result = await stripe.confirmCardPayment(client_secret, {
        payment_method: {
          card: cardElement,
          billing_details: {
            name: `${orderData.first_name} ${orderData.last_name}`,
            email: orderData.email,
          },
        },
      });

      if (result.error) {
        setLoading(false);
      } else if (result.paymentIntent.status === "succeeded") {
        onSuccess(result.paymentIntent.id);
        // no need to stop loader – user navigates next
      }
    } catch (err) {
      console.error("Stripe error:", err);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handlePayment} className="p-4 border rounded-lg mt-6">
      <h3 className="text-lg font-semibold mb-4">Pay with Card</h3>

      <CardElement className="p-3 border rounded" />

      <button
        type="submit"
        disabled={!stripe || loading}
        className={`w-full mt-4 py-3 rounded text-white flex items-center justify-center gap-2
          ${loading ? "bg-gray-600 cursor-not-allowed" : "bg-black hover:bg-gray-800"}
        `}
      >
        {loading && (
          <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
        )}
        {loading ? "Processing..." : "Pay Now"}
      </button>
    </form>
  );
};

/* =========================
   STRIPE WRAPPER
========================= */
const StripeCheckout = ({ orderData, onSuccess, validateForm }) => (
  <Elements stripe={stripePromise}>
    <CheckoutForm
      orderData={orderData}
      onSuccess={onSuccess}
      validateForm={validateForm}
    />
  </Elements>
);

export default StripeCheckout;
